import router from '@/router'
import { vendorPanelApi } from '@/services/vendorPanelApi'
import {
  emitVendorNotificationsUpdated,
  resolveVendorNotificationRoute,
} from '@/utils/vendorNotifications'
import {
  initVendorWebPushNotifications,
  unregisterVendorWebPushToken,
} from '@/services/webPushNotifications'

function navigateFromPushData(data = {}) {
  const route = resolveVendorNotificationRoute({
    redirectType: data.redirect_type,
    adId: Number(data.ad_id || 0) || null,
    companyId: Number(data.company_id || 0) || null,
    data,
  })

  if (route) {
    router.push(route).catch(() => {})
  }
}

export function setupVendorWebPush() {
  if (!localStorage.getItem('accessToken')) {
    return
  }

  initVendorWebPushNotifications({
    registerToken: payload => vendorPanelApi.registerDeviceToken(payload),
    onForegroundMessage: () => {
      emitVendorNotificationsUpdated({ refreshList: true })
    },
    onNotificationClick: data => {
      emitVendorNotificationsUpdated({ refreshList: true })
      navigateFromPushData(data)
    },
  }).catch(() => {})
}

export function teardownVendorWebPush() {
  unregisterVendorWebPushToken(payload => vendorPanelApi.removeDeviceToken(payload)).catch(() => {})
}
